import mainImage from './travel_thermos.jpg';
import image1 from './travel_thermos1.jpg';
import image2 from './travel_thermos2.jpg';
import image3 from './travel_thermos3.jpg';

const details = [
    { 
      id: 4,
      name: 'Kids Travel Thermos',
      slideTitle: 'Travel Thermos',
      slideImage: mainImage,
      images: [mainImage, image1, image2, image3],
      description: 'Aside from the typical use of packing warm pasta or soup for your kids for their lunch, I like to use the thermos to pack mini pancakes for my kids on the go. Whether they need to eat a quick breakfast in the car, or an on-the-go version of my family\'s favorite Friday night meal, Breakfast for Dinner, the travel thermos comes in handy. The other most commonly made food to go into the thermos is mac n cheese — and easy to make in the morning and divide between 2 thermoses for my 2 kids!',
      link: 'https://amzn.to/4feFuWo'

    }
]

export default details[0];